import {Inject, Injectable, isDevMode, PLATFORM_ID} from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import {Observable} from 'rxjs/internal/Observable';
import {BaseStoreService} from '@core/abstract/store.abstract';
import {IServerOptions} from '@core/model/serverOptions';
import {IServerOptionsResolved} from '@core/model/HTTP/Resolver/store';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class StoreServerOptionsResolver implements Resolve<IServerOptionsResolved> {

  constructor(private baseStoreService: BaseStoreService, @Inject(PLATFORM_ID) private platformId: object) {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IServerOptionsResolved> {
    if (!isPlatformBrowser(this.platformId))
      return of({
        serverOptions: {
          maintenance: true
        },
        error: 'Not a browser'
      });


    return this.baseStoreService.getServerOptions().pipe(
      map((serverOptions: IServerOptions) => ({serverOptions} as IServerOptionsResolved)),
      catchError(err => {
        return of({
          serverOptions: {
            maintenance: true
          },
          error: err
        } as IServerOptionsResolved);
      })
    );
  }
}
